export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const IS_EXPIRED = '_isExpired';

export const HAS_LOGGED_IN = 'has_logged_in';

export const USER_ID = 'id_token';
